import React, { useState } from 'react';
import FontAwesome from 'react-fontawesome';
import { useMountEffect } from '~/util';
import { droppedStickersApi } from '~/Providers/Api';
import NoScrollBar from '../NoScrollBar/NoScrollBar';
import StickerDrag from './StickerDrag';

const RecentStickers = () => {
  const [stickers, setStickers] = useState([]);

  useMountEffect(() => {
    droppedStickersApi.recent().then(({ data }) => {
      setStickers(data);
    });
  });

  return (
    <>
      <div className="sticker-packs">
        <NoScrollBar showScrollOnHover>
          <div className="sticker-pack active">
            <div className="product">
              <div className="premium center">
                <FontAwesome className="star" name="star" size="lg" />
                RECENT
              </div>
            </div>
            {stickers.map((sticker, index) => (
              <StickerDrag
                showDelete={false}
                sticker={{
                  ...sticker,
                  pivot: { sticker_id: sticker.id, sticker_pack_id: sticker.sticker_pack_id },
                }}
                key={index}
              />
            ))}
          </div>
        </NoScrollBar>
      </div>
    </>
  );
};

RecentStickers.propTypes = {};

export default RecentStickers;
